// extracted by mini-css-extract-plugin
export default {"select":"ValueCreate_select__umzJK"};